module.exports = __webpack_public_path__ + "static/media/print-solid.272ab024.svg";